import { mainInstance } from "api";
import { PAGE_SIZE, PAGE_SIZE_LARGE } from "utils/Constans";
const getOnlineExamResults = async (
  { schoolId, semesterId, studentId, body },
  page
) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamResults/${schoolId}/${semesterId}/Student/${studentId}/Results`,
    { ...body, pageIndex: page }
  );
  return data.data;
};

const getOnlineExams = async (
  { filterBody, schoolId, semesterId, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExams?SemesterId=${semesterId}&SchoolId=${schoolId}&PageIndex=${page}&PageSize=${pageSize}&SchoolClassId=${
      filterBody?.schoolClass || ""
    }&ClassBaseId=${filterBody?.classBase || ""}&Title=${
      filterBody?.name || ""
    }&StartDate=${filterBody?.date || ""}&CourseId=${
      filterBody?.course || ""
    }&status=${filterBody?.status || ""}`
  );
  return data.data;
};

const getOnlineExamResultChart = async ({
  body,
  schoolId,
  semesterId,
  studentId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamResults/${schoolId}/${semesterId}/Student/${studentId}/ChartResult`,
    body
  );
  return data.data;
};

const getOnlineExamCourseChart = async ({
  body,
  schoolId,
  semesterId,
  studentId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamResults/${schoolId}/${semesterId}/Student/${studentId}/ChartCourseResult`,
    body
  );
  return data.data;
};
const getOnlineExamDetail = async ({ semesterId, id }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExams/${semesterId}/${id}`
  );
  return data.data;
};
const getOnlineExamDetailWithClasses = async ({ id }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExams/${id}/DetailsWithClasses`
  );
  return data.data;
};

const deleteOnlineExam = async ({ semesterId, examId }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/OnlineExams/${semesterId}/${examId}`
  );
  return data.data;
};

const copyOnlineExam = async ({ semesterId, schoolId, examId }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/OnlineExam/${schoolId}/${semesterId}/${examId}/Copy`
  );
  return data.data;
};

const createOnlineExamTemplate = async ({
  body,
  semesterId,
  schoolId,
  examId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExam/${schoolId}/${semesterId}/${examId}/CreateTemplate`,
    body
  );
  return data.data;
};
const postQuestionList = async ({ body, semesterId, isRelease, examId }) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamQuestions/OnlineExams/${semesterId}/${examId}/PostList/${isRelease}`,
    body
  );
  return data.data;
};
const editOnlineExam = async ({ body }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/OnlineExams`,
    body
  );
  return data.data;
};
const postOnlineExam = async ({ body }) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExams`,
    body
  );
  return data.data;
};

const patchQuestionList = async ({ semesterId, OnlineExamId, body }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/OnlineExamQuestions/OnlineExams/${semesterId}/${OnlineExamId}/PatchList`,
    body
  );
  return data.data;
};

const getOnlineExamResultCount = async ({ semesterId, schoolId, examId }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExams/${schoolId}/${semesterId}/${examId}/CountResult`
  );
  return data.data;
};

const getOnlineExamResultClasses = async (
  { examId, schoolId, semesterId, pageSize = PAGE_SIZE_LARGE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExam/${schoolId}/${semesterId}/${examId}/ReportClasses?pageIndex=${page}&pageSize=${pageSize}`
  );
  return data.data;
};
const getOnlineExamResultStudents = async (
  { examId, schoolId, semesterId, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamQuestions/${schoolId}/${semesterId}/${examId}/DetailsStudents?pageSize=${pageSize}&pageIndex=${page}`
  );
  return data.data;
};

const deleteOnlineExamResult = async ({ examResultId, studentId, examId }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/OnlineExamResults/${examId}/${studentId}/${examResultId}`
  );
  return data.data;
};

const deleteOnlineExamQuestion = async ({ id }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/OnlineExamQuestions/${id}`
  );
  return data.data;
};
const getOnlineExamResultByFilter = async (
  { examId, semesterId, body },
  page
) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamResults/${semesterId}/${examId}/GetByFilter`,
    { ...body, pageIndex: page }
  );
  return data.data;
};

const getOnlineExamStudentWithoutResult = async (
  { examId, schoolId, semesterId },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExam/${schoolId}/${semesterId}/${examId}/NotStudentResults?pageIndex=${page}&pageSize=${PAGE_SIZE}`
  );
  return data.data;
};
const getOnlineExamStudentWorkBook = async ({
  examId,
  studentId,
  semesterId,
}) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamResults/${semesterId}/${examId}/${studentId}/Details`
  );
  return data.data;
};

const postOnlineExamCorrection = async ({
  examResultId,
  body,
  studentId,
  schoolId,
  semesterId,
}) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/OnlineExamResults/${schoolId}/${semesterId}/Correction/${studentId}/${examResultId}`,
    body
  );
  return data.data;
};
export {
  getOnlineExamResults,
  getOnlineExams,
  getOnlineExamResultChart,
  getOnlineExamCourseChart,
  deleteOnlineExam,
  copyOnlineExam,
  createOnlineExamTemplate,
  postQuestionList,
  getOnlineExamDetail,
  editOnlineExam,
  postOnlineExam,
  getOnlineExamDetailWithClasses,
  patchQuestionList,
  getOnlineExamResultCount,
  getOnlineExamResultClasses,
  getOnlineExamResultStudents,
  getOnlineExamResultByFilter,
  deleteOnlineExamResult,
  getOnlineExamStudentWithoutResult,
  deleteOnlineExamQuestion,
  getOnlineExamStudentWorkBook,
  postOnlineExamCorrection,
};
